import { useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
interface DropdownProps {
  dataSource: any[];
  defaultValue: any;
  field: string;
  selectionChanged: Function;
  className?: string;
  inline?: boolean;
}
export default (props: DropdownProps) => {
  const { dataSource, defaultValue, field, selectionChanged, inline } = props;
  const [item, setItem] = useState<any>(defaultValue);

  const getData = (value: any, field?: string) => {
    return field ? value[field] : value;
  };

  const handleSelection = (val: any) => {
    setItem(val);
    if (selectionChanged) selectionChanged(val);
  };

  return (
    <DropdownButton
      className={inline ? "inline-dropdown" : ""}
      title={getData(item, field)}
      size="sm"
      variant="success"
    >
      {dataSource.map((val, index) => {
        return (
          <Dropdown.Item
            key={index}
            onSelect={() => {
              handleSelection(val);
            }}
          >
            {getData(val, field)}
          </Dropdown.Item>
        );
      })}
    </DropdownButton>
  );
};
